import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import store from './../store'

import SignOut from "@/views/SignOut.vue"

import SignIn from "@/views/teacher/SignIn.vue"
import SignInTwoFactor from "@/views/teacher/SignInTwoFactor.vue"
import TeacherAuthorizedCallback from '@/views/teacher/AuthorizedCallback.vue'
import TeacherSingleSignOn from "@/views/teacher/SingleSignOn.vue"
import SheetList from "@/views/teacher/SheetList.vue"
import ApprovalSheetList from "@/views/teacher/ApprovalSheetList.vue"
import LessonSheetList from "@/views/teacher/LessonSheetList.vue"
import CampusList from "@/views/teacher/CampusList.vue"
import CampusUpload from "@/views/teacher/CampusUpload.vue"
import CourseList from "@/views/teacher/CourseList.vue"
import CourseUpload from "@/views/teacher/CourseUpload.vue"
import ClassificationList from "@/views/teacher/ClassificationList.vue"
import ClassificationUpload from "@/views/teacher/ClassificationUpload.vue"
import CurriculumList from "@/views/teacher/CurriculumList.vue"
import CurriculumUpload from "@/views/teacher/CurriculumUpload.vue"
import SubjectList from "@/views/teacher/SubjectList.vue"
import SubjectUpload from "@/views/teacher/SubjectUpload.vue"
import StudentList from "@/views/teacher/StudentList.vue"
import StudentUpload from "@/views/teacher/StudentUpload.vue"
import StudentSubjectList from "@/views/teacher/StudentSubjectList.vue"
import StudentSubjectUpload from "@/views/teacher/StudentSubjectUpload.vue"
import StudentSubjectReportList from "@/views/teacher/StudentSubjectReportList.vue"
import StudentSubjectReportUpload from "@/views/teacher/StudentSubjectReportUpload.vue"
import LessonList from "@/views/teacher/LessonList.vue"
import LessonClassEdit from "@/views/teacher/LessonClassEdit.vue"
import LessonUpload from "@/views/teacher/LessonUpload.vue"
import StudentSeisekiList from "@/views/teacher/StudentSeisekiList.vue"
import ProgressSheetList from "@/views/teacher/ProgressSheetList.vue"
import ProgressStudentList from "@/views/teacher/ProgressStudentList.vue"
import SaitenResultDownload from "@/views/teacher/SaitenResultDownload.vue"
import SaitenCountDownload from "@/views/teacher/SaitenCountDownload.vue"
import LessonKyouzaiList from "@/views/teacher/LessonKyouzaiList.vue"
import QuestionnaireResultDownload from "@/views/teacher/QuestionnaireResultDownload.vue"

// 生徒サイト
import StudentSignin from "@/views/student/SignIn.vue";
import StudentAuthorizedCallBack from "@/views/student/AuthorizedCallback.vue";
import StudentSheetList from "@/views/student/SheetList.vue";
import StudentArchiveSheetList from "@/views/student/SheetArchiveList.vue";
import DigitalReport from "@/views/student/DigitalReport.vue";
import ResultImagePreview from "@/views/student/ResultImagePreview.vue";
import CorrectImagePreview from "@/views/student/CorrectImagePreview.vue";
import StudentLessonClassList from "@/views/student/LessonClassList.vue";
import StudentLessonClass from "@/views/student/LessonClass.vue";
import SingleSignOn from "@/views/student/SingleSignOn.vue";

// レポートマスタ管理
import BaseSheetList from "@/views/teacher/BaseSheetList.vue"
import BaseSheetEdit from "@/views/teacher/BaseSheetEdit.vue"
import BaseSheetUpload from "@/views/teacher/BaseSheetUpload.vue"
import ApprovalBaseSheetList from "@/views/teacher/ApprovalBaseSheetList.vue"
import ApprovalBaseSheetEdit from "@/views/teacher/ApprovalBaseSheetEdit.vue"
import ApprovalBaseSheetUpload from "@/views/teacher/ApprovalBaseSheetUpload.vue"
import LessonClassList from "@/views/teacher/LessonClassList.vue"
import LessonClassUpload from "@/views/teacher/LessonClassUpload.vue"
import QrBaseSheetList from "@/views/teacher/QrBaseSheetList.vue"
import QrBaseSheetUpload from "@/views/teacher/QrBaseSheetUpload.vue"
import FieldEdit from "@/views/teacher/FieldEdit.vue"
import CorrectImageUpload from "@/views/teacher/CorrectImageUpload.vue"
import PositionEdit from "@/views/teacher/PositionEdit.vue"
import ScorePositionEdit from "@/views/teacher/ScorePositionEdit.vue"
import QuestionImageUpload from "@/views/teacher/QuestionImageUpload.vue"
import ExplanationImageUpload from "@/views/teacher/ExplanationImageUpload.vue"
import AnswerImageUpload from "@/views/teacher/AnswerImageUpload.vue"
import LessonQuestionnaireEdit from "@/views/teacher/LessonQuestionnaireEdit.vue"
import AutoReviewTemplateEdit from "@/views/teacher/AutoReviewTemplateEdit.vue"
import MovieContentUpload from "@/views/teacher/MovieContentUpload.vue"

import WebupList from "@/views/teacher/WebupList.vue"
import WebupDetail from "@/views/teacher/WebupDetail.vue"
import SheetUpload from "@/views/teacher/SheetUpload.vue"
import IkkatsuFieldUpload from "@/views/teacher/IkkatsuFieldUpload.vue"
import IkkatsuCorrectImageUpload from "@/views/teacher/IkkatsuCorrectImageUpload.vue"
import IkkatsuAnswerSheetUpload from "@/views/teacher/IkkatsuAnswerSheetUpload.vue"
import IkkatsuQuestionUpload from "@/views/teacher/IkkatsuQuestionUpload.vue"

// 採点
import SaitenList from "@/views/teacher/SaitenList.vue"
import SaitenInputSeigo from "@/views/teacher/SaitenInputSeigo.vue"
import SaitenInputScoreStamp from "@/views/teacher/SaitenInputScoreStamp.vue"
import SaitenInputQuestionPdf from "@/views/teacher/SaitenInputQuestionPdf.vue"
import SaitenInputIchimai from "@/views/teacher/SaitenInputIchimai.vue"

// 教師管理
import TeacherList from "@/views/teacher/TeacherList.vue";
import TeacherCreate from "@/views/teacher/TeacherCreate.vue";
import TeacherUpload from "@/views/teacher/TeacherUpload.vue";
import UserResultViewableRangeList from "@/views/teacher/UserResultViewableRangeList.vue";
import UserResultViewableRangeUpload from "@/views/teacher/UserResultViewableRangeUpload.vue";
import UserScorableRangeList from "@/views/teacher/UserScorableRangeList.vue";
import UserScorableRangeUpload from "@/views/teacher/UserScorableRangeUpload.vue";

// ユーザ管理
import UserEdit from "@/views/teacher/UserEdit.vue";

// 学校管理
import SchoolList from "@/views/teacher/SchoolList.vue";
import SchoolEdit from "@/views/teacher/SchoolEdit.vue";

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  { path: "/", name: "SignIn", component: SignIn },
  { path: "/sign_out", name: "SignOut", component: SignOut },
  { path: "/sso/teacher_authorize", name: "TeacherSingleSignOn", component: TeacherSingleSignOn },
  { path: "/teacher_site/sign_in_two_factor", name: "SignInTwoFactor", component: SignInTwoFactor },
  { path: "/teacher_site/sheet_list", name: "SheetList", component: SheetList },
  { path: "/teacher_site/approval_sheet_list", name: "ApprovalSheetList", component: ApprovalSheetList },
  { path: "/teacher_site/lesson_sheet_list", name: "LessonSheetList", component: LessonSheetList },
  { path: "/teacher_site/campus_list", name: "CampusList", component: CampusList },
  { path: "/teacher_site/campus_upload", name: "CampusUpload", component: CampusUpload },
  { path: "/teacher_site/course_list", name: "CourseList", component: CourseList },
  { path: "/teacher_site/course_upload", name: "CourseUpload", component: CourseUpload },
  { path: "/teacher_site/classification_list", name: "ClassificationList", component: ClassificationList },
  { path: "/teacher_site/classification_upload", name: "ClassificationUpload", component: ClassificationUpload },
  { path: "/teacher_site/curriculum_list", name: "CurriculumList", component: CurriculumList },
  { path: "/teacher_site/curriculum_upload", name: "CurriculumUpload", component: CurriculumUpload },
  { path: "/teacher_site/subject_list", name: "SubjectList", component: SubjectList },
  { path: "/teacher_site/subject_upload", name: "SubjectUpload", component: SubjectUpload },
  { path: "/teacher_site/student_list", name: "StudentList", component: StudentList },
  { path: "/teacher_site/student_upload", name: "StudentUpload", component: StudentUpload },
  { path: "/teacher_site/student_subject_list", name: "StudentSubjectList", component: StudentSubjectList },
  { path: "/teacher_site/student_subject_upload", name: "StudentSubjectUpload", component: StudentSubjectUpload },
  { path: "/teacher_site/student_subject_report_list", name: "StudentSubjectReportList", component: StudentSubjectReportList },
  { path: "/teacher_site/student_subject_report_upload", name: "StudentSubjectReportUpload", component: StudentSubjectReportUpload },
  { path: "/teacher_site/lesson_upload", name: "LessonUpload", component: LessonUpload },
  { path: "/teacher_site/lesson_list", name: "LessonList", component: LessonList },
  { path: "/teacher_site/student_seiseki_list", name: "StudentSeisekiList", component: StudentSeisekiList },
  { path: "/teacher_site/progress_sheet_list", name: "ProgressSheetList", component: ProgressSheetList },
  { path: "/teacher_site/progress_student_list/:base_sheet_id", name: "ProgressStudentList", component: ProgressStudentList },
  { path: "/teacher_site/lesson_kyouzai_list/:lesson_class_id", name: "LessonKyouzaiList", component: LessonKyouzaiList },
  { path: "/teacher_site/questionnaire_result_download", name: "QuestionnaireResultDownload", component: QuestionnaireResultDownload },

  // 生徒サイト
  { path: "/:school_url_prefix/student_site/sign_in", name: "StudentSignin", component: StudentSignin },
  { path: "/:school_url_prefix/student_site/sign_in/:errorKind", name: "StudentSigninWithErrorKind", component: StudentSignin },
  { path: "/:school_url_prefix/student_site/authorized_callback", name: "StudentAuthorizedCallBack", component: StudentAuthorizedCallBack },
  { path: "/:school_url_prefix/student_site/sheet_list", name: "StudentSheetList", component: StudentSheetList },
  { path: "/:school_url_prefix/student_site/lesson_class_list", name: "StudentLessonClassList", component: StudentLessonClassList },
  { path: "/:school_url_prefix/student_site/sheet_archive_list", name: "StudentArchiveSheetList", component: StudentArchiveSheetList },
  { path: "/:school_url_prefix/student_site/digital_report/:subject_code/:nendo/:report_no", name: "DigitalReport", component: DigitalReport },
  { path: "/:school_url_prefix/student_site/digital_report/:subject_code/:nendo/:report_no/:times", name: "DigitalReportWithTimes", component: DigitalReport },
  { path: "/:school_url_prefix/student_site/result_image_preview/:student_sheet_id", name: "ResultImagePreview", component: ResultImagePreview },
  { path: "/:school_url_prefix/student_site/correct_image_preview/:base_sheet_id", name: "CorrectImagePreview", component: CorrectImagePreview },
  { path: "/:school_url_prefix/student_site/lesson_class/:lesson_class_id", name: "StudentLessonClass", component: StudentLessonClass },
  { path: "/sso/authorize", name: "SingleSignOn", component: SingleSignOn },

  { path: "/teacher_site/base_sheet_list", name: "BaseSheetList", component: BaseSheetList },
  { path: "/teacher_site/base_sheet_edit/:base_sheet_id", name: "BaseSheetEdit", component: BaseSheetEdit },
  { path: "/teacher_site/base_sheet_upload", name: "BaseSheetUpload", component: BaseSheetUpload },
  { path: "/teacher_site/approval_base_sheet_list", name: "ApprovalBaseSheetList", component: ApprovalBaseSheetList },
  { path: "/teacher_site/approval_base_sheet_edit/:base_sheet_id", name: "ApprovalBaseSheetEdit", component: ApprovalBaseSheetEdit },
  { path: "/teacher_site/approval_base_sheet_upload", name: "ApprovalBaseSheetUpload", component: ApprovalBaseSheetUpload },
  { path: "/teacher_site/lesson_class_list", name: "LessonClassList", component: LessonClassList },
  { path: "/teacher_site/lesson_class_edit/:lesson_class_id", name: "LessonClassEdit", component: LessonClassEdit },
  { path: "/teacher_site/lesson_class_upload", name: "LessonClassUpload", component: LessonClassUpload },
  { path: "/teacher_site/qr_base_sheet_list", name: "QrBaseSheetList", component: QrBaseSheetList },
  { path: "/teacher_site/qr_base_sheet_upload", name: "QrBaseSheetUpload", component: QrBaseSheetUpload },
  { path: "/teacher_site/field_edit/:base_sheet_id", name: "FieldEdit", component: FieldEdit },
  { path: "/teacher_site/correct_image_upload/:base_sheet_id", name: "CorrectImageUpload", component: CorrectImageUpload },
  { path: "/teacher_site/position_edit/:base_sheet_id", name: "PositionEdit", component: PositionEdit },
  { path: "/teacher_site/score_position_edit/:base_sheet_id", name: "ScorePositionEdit", component: ScorePositionEdit },
  { path: "/teacher_site/question_image_upload/:base_sheet_id", name: "QuestionImageUpload", component: QuestionImageUpload },
  { path: "/teacher_site/explanation_image_upload/:base_sheet_id", name: "ExplanationImageUpload", component: ExplanationImageUpload },
  { path: "/teacher_site/answer_image_upload/:base_sheet_id", name: "AnswerImageUpload", component: AnswerImageUpload },
  { path: "/teacher_site/lesson_questionnaire_edit/:lesson_class_id", name: "LessonQuestionnaireEdit", component: LessonQuestionnaireEdit },
  { path: "/teacher_site/auto_review_template_edit/:base_sheet_id", name: "AutoReviewTemplateEdit", component: AutoReviewTemplateEdit },
  { path: "/teacher_site/movie_content_upload/:base_sheet_id", name: "MovieContentUpload", component: MovieContentUpload },
  { path: "/teacher_site/webup_list", name: "WebupList", component: WebupList }, 
  { path: "/teacher_site/webup_detail/:webup_history_id", name: "WebupDetail", component: WebupDetail }, 
  { path: "/teacher_site/sheet_upload/:sheet_id", name: "SheetUpload", component: SheetUpload }, 
  { path: "/teacher_site/saiten_list/:sheet_id", name: "SaitenList", component: SaitenList }, 
  { path: "/teacher_site/saiten_input_seigo/:sheet_id/:sheet_field_id", name: "SaitenInputSeigo", component: SaitenInputSeigo },
  { path: "/teacher_site/saiten_input_score_stamp/:sheet_id/:sheet_field_id", name: "SaitenInputScoreStamp", component: SaitenInputScoreStamp },
  { path: "/teacher_site/saiten_input_ichimai/:sheet_id/:examinee_id", name: "SaitenInputIchimai", component: SaitenInputIchimai },
  { path: "/teacher_site/saiten_input_question_pdf/:base_sheet_id", name: "SaitenInputQuestionPdf", component: SaitenInputQuestionPdf },
  { path: "/teacher_site/ikkatsu_field_upload", name: "IkkatsuFieldUpload", component: IkkatsuFieldUpload },
  { path: "/teacher_site/ikkatsu_correct_image_upload", name: "IkkatsuCorrectImageUpload", component: IkkatsuCorrectImageUpload },
  { path: "/teacher_site/ikkatsu_answer_sheet_upload", name: "IkkatsuAnswerSheetUpload", component: IkkatsuAnswerSheetUpload },
  { path: "/teacher_site/ikkatsu_question_upload", name: "IkkatsuQuestionUpload", component: IkkatsuQuestionUpload },

  { path: "/teacher_site/saiten_result_download", name: "SaitenResultDownload", component: SaitenResultDownload },
  { path: "/teacher_site/saiten_count_download", name: "SaitenCountDownload", component: SaitenCountDownload },
  { path: "/teacher_site/teacher_list", name: "TeacherList", component: TeacherList},
  {
    path: "/teacher_site/teacher_create",
    name: "TeacherCreate",
    component: TeacherCreate,
    beforeEnter: (to, from, next) => {
      const queryRole = to.query?.["role"];
      const currentUser = store.state.currentUser;

      if (!currentUser?.role || (queryRole == "admin" && currentUser.role != "admin")) {
        store.state.currentUser = null;
        document.cookie = 'access_token=';
        document.cookie = 'smarky_user_id=';
        next({path: "/"});
      } else {
        next();
      }
    }
  },
  { path: "/teacher_site/teacher_upload", name: "TeacherUpload", component: TeacherUpload},

  { path: "/teacher_site/user_edit", name: "UserEdit", component: UserEdit },

  { path: "/teacher_site/uesr_result_viewable_range_list", name: "UserResultViewableRangeList", component: UserResultViewableRangeList},
  { path: "/teacher_site/uesr_result_viewable_range_upload", name: "UserResultViewableRangeUpload", component: UserResultViewableRangeUpload},
  { path: "/teacher_site/uesr_scorable_range_list", name: "UserScorableRangeList", component: UserScorableRangeList},
  { path: "/teacher_site/uesr_scorable_range_upload", name: "UserScorableRangeUpload", component: UserScorableRangeUpload},

  {
    path: "/teacher_site/school_list",
    name: "SchoolList",
    component: SchoolList,
    beforeEnter: (to, from, next) => {
      const currentUser = store.state.currentUser;

      if (!currentUser?.role || currentUser.role != "admin") {
        store.state.currentUser = null;
        document.cookie = 'access_token=';
        document.cookie = 'smarky_user_id=';
        next({path: "/"});
      } else {
        next();
      }
    }
  },
  {
    path: "/teacher_site/school_edit",
    name: "SchoolEdit",
    component: SchoolEdit,
    beforeEnter: (to, from, next) => {
      const currentUser = store.state.currentUser;

      if (!currentUser?.role || currentUser.role != "admin") {
        store.state.currentUser = null;
        document.cookie = 'access_token=';
        document.cookie = 'smarky_user_id=';
        next({path: "/"});
      } else {
        next();
      }
    }
  },

  { path: "/teacher_site/student_ref/sheet_list", name: "StudentSheetListByTeacher", component: StudentSheetList },
  { path: "/teacher_site/student_ref/sheet_archive_list", name: "StudentArchiveSheetListByTeacher", component: StudentArchiveSheetList },
  { path: "/teacher_site/student_ref/lesson_class_list", name: "StudentLessonClassListByTeacher", component: StudentLessonClassList },
  { path: "/teacher_site/student_ref/lesson_class/:lesson_class_id", name: "StudentLessonClassByTeacher", component: StudentLessonClass },
  { path: "/teacher_site/authorized_callback", name: "TeacherAuthorizedCallback", component: TeacherAuthorizedCallback },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
